import React from 'react'
import Searchblog from './Search_blog/Searchblog'
import Toparticels from './Toparticles/Toparticels'
import styles from './Rightside.module.css'
import Media from './Media/Media'
const Rightside = () => {
    // className = { styles.scrollable }
    return (
        <div style={{ width:"360px" }} className={styles.right}>
            <Searchblog />
            <Toparticels />
            <Media/>
        </div>
    )
}

export default Rightside
